export default "__VITE_ASSET__T98g5lj9__"